var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.$store.getters.loading,
          expression: "$store.getters.loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "app-main",
      style: Object.assign({}, _vm.$route.meta.style),
      attrs: {
        "element-loading-text": "加载中",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(0, 0, 0, 0.2)",
      },
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade-transform", mode: "out-in" } },
        [
          _c(
            "keep-alive",
            [
              _vm.$route.meta.keepAlive
                ? _c("router-view", { key: _vm.key })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade-transform", mode: "out-in" } },
        [
          !_vm.$route.meta.keepAlive
            ? _c("router-view", { key: _vm.key })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }